import SectionHeading from './SectionHeading'
import DataCard from './DataCard'
import './SkillGroup.css'
import { FaCode } from 'react-icons/fa'

const SkillGroup = ({ id, title, categories }) => (
  <section className="skill-group" id={id}>
    <SectionHeading>{title}</SectionHeading>
    {categories.map((cat, i) => (
      <div key={i} className="skill-group__category">
        <SectionHeading sub icon={cat.icon || <FaCode />}>{cat.label}</SectionHeading>
        <div className="skill-group__content">
          {cat.items.map((item, j) => (
            <DataCard key={j} fields={[item.name]} badge />
          ))}
        </div>
      </div>
    ))}
  </section>
)

export default SkillGroup
